import { Controller } from '@hotwired/stimulus';
import EventPublisher from './event_publisher';

export default class extends Controller {
  static targets = [
    'layoutCanvas',
    'manageProducts',
    'products',
    'landmarks',
    'manageProductsTab',
    'productsTab',
    'sections'
  ]

  static values = {
    layoutId: Number,
    destinationId: Number
  }

  async loadLayout(Client, Renderer, readOnly = false, canvasSize = {}) {
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    const date = document.getElementById('layout_start_date')?.value;
    this.client = new Client(this.layoutIdValue, this.destinationIdValue, token);
    const products = await this.client.fetchLayoutProducts();
    this.positions = await this.client.fetchPositions();
    this.rentalPeriods = await this.client.fetchRentalPeriods(this.positions, date, readOnly);
    this.landmarks = await this.client.fetchLandmarks();
    this.sections = await this.client.fetchSections();
    this.renderer = new Renderer(this.layoutCanvasTarget, this.positions, this.landmarks, this.rentalPeriods, readOnly, canvasSize);
    this.renderer.render();
    EventPublisher.publish('landmarks-loaded', { landmarks: this.landmarks });
    EventPublisher.publish('sections-loaded', { sections: this.sections });
    EventPublisher.publish('products-loaded', { products: products });
    EventPublisher.publish('positions-loaded', { positions: this.positions });
  }

  activateTab(target) {
    document.querySelectorAll('li.layout__tab').forEach(selector => {
      selector.classList.remove('layout__active-tab');
    });
    target.classList.add('layout__active-tab');
  }

  activateView(target) {
    this.getViewTargets().forEach(view => view.classList.add('hidden'))
    target.classList.remove('hidden');
  }

  showProducts = () => {
    this.activateView(this.productsTarget);
    this.activateTab(this.productsTabTarget);
  }

  showManageProducts = () => {
    this.activateTab(this.manageProductsTabTarget);
    this.activateView(this.manageProductsTarget);
  }

  getViewTargets() {
    return [
      this.manageProductsTarget,
      this.productsTarget
    ];
  }
}
